import { createContext, ReactNode } from "react";
import {
  isRTL,
  type SupportedLanguage,
  type TranslationFunction,
} from "./types";

interface ComponentsTranslationsContextValue {
  language: SupportedLanguage;
  t: TranslationFunction;
  rtl: boolean;
}

const TranslationsContext =
  createContext<ComponentsTranslationsContextValue | null>(null);

interface ComponentsLocaleProviderProps {
  language: SupportedLanguage;
  t: TranslationFunction;
  children: ReactNode;
}

export function ComponentsLocaleProvider({
  language,
  t,
  children,
}: ComponentsLocaleProviderProps) {
  const rtl = isRTL(language);

  return (
    <TranslationsContext value={{ language, t, rtl }}>
      {children}
    </TranslationsContext>
  );
}

export { TranslationsContext };
